export default {
    zh:{
        detailTitle: '产品报价确认明细'
    },
    en:{
        detailTitle: 'Product Sourcing Detail'
    }
}
